export const GET_PREVIOUS_INVITES = 'GET_PREVIOUS_INVITES';
export const GET_PREVIOUS_INVITES_ERROR = 'GET_PREVIOUS_INVITES_ERROR';
export const GET_PREVIOUS_INVITES_SUCCESS = 'GET_PREVIOUS_INVITES_SUCCESS';

export const DELETE_INVITE = 'DELETE_INVITE';
export const DELETE_INVITE_ERROR = 'DELETE_INVITE_ERROR';
export const DELETE_INVITE_SUCCESS = 'DELETE_INVITE_SUCCESS';